import { LeadStatusEnum, type LeadStatus } from '@flashpoint/site-dna';

const STAGE_HINTS: Record<LeadStatus, string> = {
  Discovery: 'Building the call sheet',
  'Demo Generated': 'Preview live, demo stamped',
  'In Pipeline': 'Locked live — work moves to GitHub',
};

interface Props {
  current: LeadStatus;
  onChange: (next: LeadStatus) => void;
  compact?: boolean;
}

export function StatusPipelineRail({ current, onChange, compact = false }: Props) {
  const flow = LeadStatusEnum.options;
  const currentIdx = flow.indexOf(current);

  return (
    <div className={compact ? 'flex flex-col gap-2' : 'space-y-2'}>
      <div className="flex items-stretch gap-1.5 overflow-x-auto pb-1" role="tablist">
        {flow.map((status, i) => {
          const isCurrent = current === status;
          const isPast = i < currentIdx;
          return (
            <button
              key={status}
              type="button"
              role="tab"
              aria-selected={isCurrent}
              onClick={() => onChange(status)}
              className={`min-w-[110px] flex-1 rounded-[12px] border px-3 py-2.5 text-left text-xs font-semibold transition ${
                isCurrent
                  ? 'border-transparent bg-nm-accent text-nm-on-accent'
                  : isPast
                    ? 'border-nm-border bg-nm-surface text-nm-ink hover:border-nm-accent'
                    : 'border-nm-border bg-nm-input text-nm-muted hover:border-nm-accent hover:text-nm-ink'
              }`}
            >
              <div className="fp-label opacity-80">{String(i + 1).padStart(2, '0')}</div>
              <div className="mt-0.5 leading-tight">{status}</div>
            </button>
          );
        })}
      </div>
      {!compact && (
        <p className="text-xs text-nm-muted">
          {STAGE_HINTS[current]} · statuses advance automatically — generate a preview or lock as
          live.
        </p>
      )}
    </div>
  );
}
